<template>
  <v-container> </v-container>
</template>

<script>
export default {
  name: 'Dashboard',
}
</script>
